// Replaces 'redux-persist-transform-immutable' (5.0.0) with a custom transform using 'redux-persist' and '@redux-devtools' serializer

import { createTransform } from 'redux-persist'
import Immutable from 'immutable'
import { immutable } from '@redux-devtools/serialize'

const { stringify, parse } = immutable(Immutable)

const immutableTransform = () =>
  createTransform(
    // Serialization
    (inboundState) => {
      return stringify(inboundState)
    },
    // Deserialization
    (outboundState) => {
      return parse(outboundState)
    }
  )

export default immutableTransform
